import { NoopTracker } from "@dpdgroupuk/react-event-tracker";

export default new NoopTracker({
  projectRef: "CT",
  debug: process.env.NODE_ENV === "development",
});
